import React from "react";
import SearchParams from '../Elements/SearchParams';
import ExchangeRateSearchParams from '../Contents/Currency/ExchangeRate/ExchangeRateSearchParams';
import ExchangeRateItem from "../Domain/ExchangeRateItem";
import AuthService from "./authService.js";

export default class ExchangeSerivce extends React.Component {
  static async GetExchangeRate(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, ExchangeRateSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    return AuthService.getInstance().CallBackendFunction(`/api/Exchange/GetExchangeRateDetailsAsync/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`);
  }

  static ConvertDBCurrencyDetails(items) {
    const convertedItems = [];
    if (items !== null) {
      items.forEach(item => {
        const newItem = new ExchangeRateItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }
}
